(function() {
    let scrolledHeight = 0;
    let wWidth = window.innerWidth;

    function menuToggle() {
        let burger = document.querySelector('.menu-toggle'),
            topBar = document.querySelector('.topBar');

        burger.addEventListener('click', function() {
            if( !burger.classList.contains('is-active') ) {
                burger.classList.add('is-active');
                topBar.classList.add('is-opened');
            } else {
                burger.classList.remove('is-active');
                topBar.classList.remove('is-opened');
            }
        });
    }

    function setMenuScrolledClass() {
        const menuContainer = document.querySelector('.topBar');
        const body = document.querySelector('body');

        if( scrolledHeight > 150 ) {
            menuContainer.classList.add('is-scrolled');
            body.classList.add('scrolled');
        } else {
            menuContainer.classList.remove('is-scrolled');
            body.classList.remove('scrolled');
        }
    }

    function submenu() {
        let button_with_submenu = document.querySelectorAll('.menu-item-has-children');

        // if( button_with_submenu && wWidth < 1210 ) {
        //     button_with_submenu.forEach(function(item, index) {
        //         item.addEventListener('click', function(e) {
        //             console.log('menu click');
        //             e.preventDefault();
        //             if( item.classList.contains('submenu-opened') ) {
        //                 item.classList.remove('submenu-opened');
        //             } else {
        //                 item.classList.add('submenu-opened');
        //             }
        //         })
        //     });
        // }
    }

    window.addEventListener('load', function() {
        menuToggle();
        submenu();
        setMenuScrolledClass();
    });

    window.addEventListener('scroll', function(e) {
        setMenuScrolledClass();
        scrolledHeight = window.pageYOffset || document.documentElement.scrollTop;
    });
    window.addEventListener('resize', function() {
        let wWidth = window.innerWidth;
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/top-menu.js
// module id = 3
// module chunks = 0